import { IChiller } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

// const apiVersion = 'v1';

const mockedData: IChiller[] = [
  {
    siteId: 1,
    siteName: 'Cooling Plant 1',
    siteLocationName: 'Cooling Plant 1',
    controlId: 1,
    controlName: 'Chiller 1',
    controlFriendlyName: 'Main Chiller Room',
    systemMetrics: {
      currentDemand: 81.5,
      currentLoad: 112,
      performance: 0.728,
      design: 0.701,
    },
    chilledWaterLoopParams: {
      flowRate: 312,
      chilledWaterSupplyTemp: 52.5,
      chilledWaterReturnTemp: 61.1,
      pumpSpeedAvg: 47,
      currentLoad: 112,
      plantCapacity: 1300,
    },
    chillersList: [
      {
        id: 1,
        name: 'Chiller 1',
        friendlyName: 'Chiller #1',
        status: true,
        supplyTemp: 52,
      },
      {
        id: 2,
        name: 'Chiller 2',
        friendlyName: 'Chiller #2',
        status: true,
        supplyTemp: 53.5,
      },
      {
        id: 3,
        name: 'Chiller 3',
        friendlyName: 'Chiller #3',
        status: false,
        supplyTemp: 54.5,
      },
      {
        id: 4,
        name: 'Chiller 4',
        friendlyName: 'Chiller #4',
        status: true,
        supplyTemp: 52,
      },
    ],
    warning: false,
    problem: false,
    fault: false,
    usageDateTime: '2023-10-01T12:00:00Z',
    timeSinceLastUpdate: '2023-10-01T12:00:00Z',
    location: 'Location 1',
    lastUpdate: '2023-10-01T12:00:00Z',
  },
];

const getChillersBySiteId = async (siteId: string | number) => {
  // const response = await window.axios.get(
  //   `${apiVersion}/AirHandlerUnits/latest-readings?siteid=${siteId}`
  // );

  // const { data } = response.data;
  // return data as IChiller[];
  console.log('Mocked data:', siteId);
  return mockedData;
};

const setChillerSetpoint = async (
  chillerId: number,
  setpoints: {
    netSupplyAirCoolingSetpoint: number;
    minSupplyAirCoolingSetpoint: number;
  }
): Promise<void> => {
  try {
    // await window.axios.put(
    //   `/${apiVersion}/AirHandlerUnits/${chillerId}/settings`,
    //   {
    //     changedSettings: {
    //       netSupplyAirCoolingSetpoint: setpoints.netSupplyAirCoolingSetpoint,
    //       minSupplyAirCoolingSetpoint: setpoints.minSupplyAirCoolingSetpoint,
    //     },
    //   }
    // );
    console.log('Setpoints updated:', chillerId, setpoints);
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getChillersBySiteId,
  setChillerSetpoint,
};
